themeBase.onDOMContentLoadedTrigger(() => {
  document.addEventListener('change', e => {
    const input = e.target.closest('.featured-collection-button');
    if (!input || input.type !== 'radio' || !input.checked) return;

    const id = input.id;
    const tpl = document.querySelector(`template[data-template-id='${id}']`);

    if (tpl) {
      const clone = tpl.content.cloneNode(true);

      tpl.replaceWith(clone);
      setTimeout(() => {
        input.checked = true;
        window.lazyImages.find();
      }, 0);
    }

    if (!themeBase.isDesktop) {
      const section = input.closest('section');
      const currentScroll = section.getAttribute('data-scrolling') || 0;

      section.querySelectorAll('.heading-wrapper__collections').forEach(el => el.scrollLeft = currentScroll);
    }
  });

  window.scrollAllToOne = function(element) {
    requestAnimationFrame(() => element.closest('section').setAttribute('data-scrolling', element.scrollLeft));
  };
});